import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface LoaderProps {
 message?: string;
 height?: number | string;
}

const Loader: React.FC<LoaderProps> = ({ message = "Loading...", height = 400 }) => {
 return (
  <Box
   sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: height,
    flexDirection: "column",
   }}
  >
   <CircularProgress />
   {message && (
    <Typography variant="body1" sx={{ mt: 2 }}>
     {message}
    </Typography>
   )}
  </Box>
 );
};

export default Loader;